<script setup lang="ts">
    // @ts-nocheck
    import { computed, onBeforeMount, onBeforeUnmount, toRefs } from "vue";
    import KFormDisplay from "@/components/forms/displays/FormDisplay/KFormDisplay.vue";
    import KFormFieldDisplay from "@/components/forms/displays/FormFieldDisplay/KFormFieldDisplay.vue";
    import { SidaLabels } from "@/tabs/Vardplatsbokning/types";
    import ButtonGroup from "@/components/ButtonGroup.vue";
    import Button from "@/components/Button.vue";
    import { useStore } from "@/store";

    const store = useStore();

    const props = defineProps<{
        vardplatsbestallningId: string | undefined;
    }>();

    const { vardplatsbestallningId } = toRefs(props);

    const emit = defineEmits(["cancel"]);

    const vardplatsbestallning = computed(() =>
        store.getters["vardplatsbestallning/vardplatsbestallningById"]({ id: vardplatsbestallningId?.value })
    );

    const cancel = (data: { target?: string | undefined; hasUnsavedData: boolean }) => {
        emit("cancel", data);
    };

    onBeforeMount(async () => {
        store.commit("vardplatsbestallning/addSubscriber");
    });

    onBeforeUnmount(() => {
        store.commit("vardplatsbestallning/removeSubscriber");
    });
</script>

<template>
    <KFormDisplay
        id="vardplatsbestallning-display"
        ref="formDisplayRef"
        class="vardplatsbestallning-display"
        :showEmptyValues="true"
    >
        <template #default>
            <div class="form-content">
                <KFormFieldDisplay
                    name="operationsdatum"
                    label="Operationsdatum"
                    validation="required"
                    :value="vardplatsbestallning?.operationsdatum"
                />
                <KFormFieldDisplay
                    name="operationstid"
                    label="Operationstid"
                    :value="vardplatsbestallning?.operationstid?.substring?.(0, 5)"
                />
                <KFormFieldDisplay
                    name="installelsedatum"
                    label="Inställelsedatum"
                    validation="required"
                    :value="vardplatsbestallning?.installelsedatum"
                />
                <KFormFieldDisplay
                    name="installelsetid"
                    label="Inställelsetid"
                    :value="vardplatsbestallning?.installelsetid?.substring?.(0, 5)"
                />
                <KFormFieldDisplay
                    name="antal_varddygn"
                    label="Antal vårddygn"
                    validation="required"
                    :value="vardplatsbestallning?.antal_varddygn"
                />
                <KFormFieldDisplay
                    name="vardgivare"
                    label="Vårdgivare"
                    validation="required"
                    :value="vardplatsbestallning?.vardgivare?.namn"
                />
                <KFormFieldDisplay
                    name="operator"
                    label="Operatör"
                    validation="required"
                    :value="vardplatsbestallning?.operator?.namn"
                />
                <KFormFieldDisplay
                    name="vardform"
                    label="Vårdform"
                    validation="required"
                    :value="vardplatsbestallning?.vardform?.namn"
                />
                <KFormFieldDisplay name="sida" label="Sida" :value="SidaLabels[vardplatsbestallning?.sida]" />
                <KFormFieldDisplay
                    name="typoperation"
                    label="Typoperation"
                    class="span-three"
                    :value="vardplatsbestallning?.typoperation"
                />
                <KFormFieldDisplay
                    name="huvuddiagnos"
                    label="Huvuddiagnos"
                    validation="required"
                    class="span-three"
                    :value="`${vardplatsbestallning?.huvuddiagnos?.code} ${vardplatsbestallning?.huvuddiagnos?.displayName}`"
                />
                <KFormFieldDisplay
                    name="huvudoperationskod"
                    label="Huvudoperationskod"
                    validation="required"
                    class="span-three"
                    :value="`${vardplatsbestallning?.huvudoperationskod?.code} ${vardplatsbestallning?.huvudoperationskod?.displayName}`"
                />
                <KFormFieldDisplay
                    name="bioperationskoder"
                    label="Bioperationskoder"
                    class="span-three"
                    :value="vardplatsbestallning?.bioperationskoder"
                    #default="{ value, emptyValue }"
                >
                    <span v-for="opkod in value" :key="opkod.id">
                        {{ opkod.code && opkod.displayName ? `${opkod.code} ${opkod.displayName}` : emptyValue }}
                    </span>
                </KFormFieldDisplay>

                <KFormFieldDisplay
                    name="info_till_vardavdelningen"
                    label="Info till vårdavdelningen"
                    class="span-two"
                    :value="vardplatsbestallning?.info_till_vardavdelningen"
                />
            </div>
        </template>
        <template #actions>
            <ButtonGroup>
                <Button @click="cancel">Stäng</Button>
            </ButtonGroup>
        </template>
    </KFormDisplay>
</template>
